import { DONT_SHOW_GLOBAL_CASE_MODAL_KEY } from '../constants/common';
import { getRemoteInstanceRedirectURL } from './common';

export const redirectToRemoteCaseDetails = (caseGUID: string) => {
  const targetUrl = `${window.FN_CONFIG.CROSS_INSTANCE_FN_URL}/case-documents?caseGUID=${encodeURIComponent(caseGUID)}`;
  window.open(getRemoteInstanceRedirectURL(targetUrl), '_blank');
};

export const shouldSkipGlobalCaseTransitionModal = () => {
  return sessionStorage.getItem(DONT_SHOW_GLOBAL_CASE_MODAL_KEY) === 'true';
};
